import React, { useState } from "react";
import styled from "styled-components";

// Components
import FontAwesomeIcon from "../../../../components/common/FontAwesomeIcon";
import CommonButton from "../../../../components/common/CommonButton";
import ModalFormSuccess from "./formTest/ModalFormSuccess";

// Services
import { postTestForm } from "../../services/testApi";

const FormTest = ({ testId }) => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        job_position: ""
    });
    const [saved, setSaved] = useState(false);
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState(false)
    const [openModal, setOpenModal] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        setError(false)
        e.preventDefault();
        const { name, email, job_position } = formData;

        if (name && email && job_position) {
            setSaving(true);
            try {
                const response = await postTestForm(testId, formData);
                if (!!response.detail) {
                    setError(true);
                    return;
                }
                setSaving(false);
                setSaved(true);
                setOpenModal(true);
            } catch (error) {
                console.log(error)
                setError(true);
                setSaving(false);
            }
        } else {
            alert("Por favor, completa todos los campos.");
        }
    };

    return (
        <>
            <ModalFormSuccess modalIsOpen={openModal} handleCloseModal={() => setOpenModal(false)} />
            <Container>
                <label>
                    <b>Ingresa tus datos y recibirás el test en tu correo electrónico:</b>
                </label>
                <form onSubmit={handleSubmit}>
                    <FormInput
                        name="name"
                        placeholder="Nombre y Apellido *"
                        type="text"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <FormInput
                        name="email"
                        placeholder="Ingresa tu correo electrónico *"
                        type="text"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <FormInput
                        name="job_position"
                        placeholder="Puesto que ocupas dentro de la empresa *"
                        type="text"
                        value={formData.job_position}
                        onChange={handleChange}
                    />
                    <label>El asterisco <b>(*)</b> indica que es un dato obligatorio.</label>
                    <ButtonsContainer>
                        {
                            saved
                                ?
                                <span>
                                    <div><FontAwesomeIcon icon="fa-light fa-circle-check" size={24} /></div>
                                    <p>Datos enviados, revisa tu correo electrónico para continuar</p>
                                </span>
                                : saving
                                    ? <SendButton type="submit" value="Enviando datos..." disabled />
                                    : <SendButton type="submit" value="Enviar datos" />
                        }
                    </ButtonsContainer>
                </form>
                {
                    error && <ErrorContainer>
                        <p>Hubo un error al guardar tus datos. Por favor, intenta de nuevo.</p>
                    </ErrorContainer>
                }
            </Container>
        </>
    );
}

export default FormTest;

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 24px;

    label {
        color: #1D1D18;
        font-size: 16px;
    }

    form {
        width: calc(100% - 4rem);
        min-height: 300px;
        height: fit-content;
        border: 1px solid #A8A8A8;
        border-radius: 20px;
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        gap: 2rem;

        label {
            font-size: 14px;
            font-weight: 700;
            color: #222;

            b {
                color: #b31d15;
            }
        }
    }
`

const FormInput = styled.input`
    width: calc(100% - 1rem);
    max-width: 480px;
    height: 56px;
    padding-left: 1rem;
    border: 0;
    border-bottom: ${({ value }) => value !== "" ? "1px solid #b31d15" : "1px solid #222"} ;

    &:focus-visible {
        outline: none;
    }
`

const SendButton = styled.input`
    height: 44px;
    width: fit-content !important;
    background-color: #CD2118;
    color: white;
    padding: 0 24px !important;
    border: none;
    border-radius: 100px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;

    &:hover {
        background-color: #B31D15;
    }
`

const ButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    span {
        background-color: #b31d15;
        padding: 12px 24px 12px 16px;
        border-radius: 100px;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        gap: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

const ErrorContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    p {
        font-size: 16px;
        color: #b31d15;
    }
`